import React, { useEffect, useMemo, useState } from "react"; // Add useState here
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaRegHeart, FaHeart } from "react-icons/fa"; // Importing icons
import OgcsVideo from "../Components/Assets/OgcsVideo.mp4";
import "./SimilarImages.css";

const SimilarImages = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Memoize the products data to prevent re-render issues
  const products = useMemo(
    () => location.state?.products || [],
    [location.state?.products]
  );

  // Add state for checking if a product is in the wishlist
  const [isInWishlist, setIsInWishlist] = useState(false);

  useEffect(() => {
    console.log("Products from backend:", products);

    // Check if the first product is in the wishlist
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    if (wishlist.some((item) => item._id === products[0]?._id)) {
      setIsInWishlist(true);
    }
  }, [products]);

  const handleCheckout = (product) => {
    navigate("/Cart", { state: { product } });
  };

  const handleAddToWishlist = (product) => {
    const existingWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const updatedWishlist = [...existingWishlist, product];
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
    setIsInWishlist(true); // Update the state to reflect the added item in wishlist
    navigate("/wishlist");
  };

  return (
    <div className="similar-images-container p-6 bg-gray-100 min-h-screen">
      <h2 className="text-3xl font-bold text-center mb-6">Similar Products</h2>

      <div className="video-grid-section mb-8 flex justify-center">
        <div className="video-box w-full sm:w-2/3 md:w-1/2">
          <video controls className="w-full rounded-lg shadow-lg">
            <source src={OgcsVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div className="similar-images-grid grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.length > 0 ? (
          products.map((product) => (
            <Link to={`/product/details/${product._id}`}>
              <div
                key={product._id}
                className="similar-image-box bg-white p-4 rounded-lg shadow-lg hover:shadow-xl transition-all"
              >
                {/* <img
                  src={`data:${product?.image?.contentType};base64,${product?.image?.data}`}
                  alt={product.name}
                  className="rounded-lg shadow-md w-full max-h-96 object-cover md:max-h-[300px] lg:max-h-[400px]"
                /> */}
                <img
                  src={product?.image}
                  onError={(e) => { e.target.src = "/placeholder.png"; }}
                  alt={product.name}
                  className="rounded-lg shadow-md w-full max-h-96 object-cover"
                />


                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {product.name}
                </h3>
                <p className="text-lg text-gray-600 mb-2">₹{product.price}</p>
                <p className="text-sm text-gray-500 mb-2">
                  {product.description}
                </p>
                <p className="text-sm text-gray-500 mb-2">
                  Category: {product.category || "N/A"}
                </p>
                <p className="text-sm text-gray-500 mb-4">
                  Subcategory: {product.subcategory || "N/A"}
                </p>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-center text-lg text-gray-600">
            No similar products found.
          </p>
        )}
      </div>

      {/* Wrap adjacent divs in a single parent (React Fragment or div) */}
      <div className="flex items-center mt-4">
        {isInWishlist ? (
          <FaHeart
            className="text-red-600 cursor-pointer"
            size={24}
            onClick={() => handleAddToWishlist(products[0])} // Passing the first product
          />
        ) : (
          <FaRegHeart
            className="text-gray-600 cursor-pointer"
            size={24}
            onClick={() => handleAddToWishlist(products[0])} // Passing the first product
          />
        )}
      </div>
    </div>
  );
};

export default SimilarImages;
